const ClassesTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 80 },
    { id: 'name', labelAr: 'اسم الحلقة', labelEn: 'Class Name' },
    { id: 'class_type', labelAr: 'النوع', labelEn: 'Type', width: 80 },
    { id: 'level_name', labelAr: 'المستوى', labelEn: 'Level', width: 120 },
    { id: 'teacher_name', labelAr: 'المعلم', labelEn: 'Teacher', width: 140 },
    { id: 'capacity', labelAr: 'السعة', labelEn: 'Cap', width: 70 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 80 },
];

export default ClassesTableColumns;
